import { Stack, TextField, useTheme, useMediaQuery } from "@mui/material";

export default function PinCodeInput({ value, onChange, length = 6 }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const values = value
    .split("")
    .concat(Array(length).fill(""))
    .slice(0, length);

  const handleChange = (index, e) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 1); // Only allow 1 digit

    // Replace the digit at current index only
    const newValueArray = value.split("");
    newValueArray[index] = val;
    
    // Trim to length and update parent
    const newValue = newValueArray.slice(0, length).join("");
    onChange(newValue);

    // Move to next if digit entered, stay if cleared
    if (val && index < length - 1) {
      const next = document.getElementById(`pin-${index + 1}`);
      if (next) next.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      
      // If current box has value, clear it
      if (values[index]) {
        const newValueArray = value.split("");
        newValueArray[index] = "";
        onChange(newValueArray.slice(0, length).join(""));
        return;
      }
      
      // If empty, move to previous and clear it
      if (index > 0) {
        const prevIndex = index - 1;
        const prev = document.getElementById(`pin-${prevIndex}`);
        const newValueArray = value.split("");
        newValueArray[prevIndex] = "";
        onChange(newValueArray.slice(0, length).join(""));
        if (prev) prev.focus();
      }
    }
    
    // Allow arrow keys for navigation
    if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault();
      const prev = document.getElementById(`pin-${index - 1}`);
      if (prev) prev.focus();
    }
    
    if (e.key === "ArrowRight" && index < length - 1) {
      e.preventDefault();
      const next = document.getElementById(`pin-${index + 1}`);
      if (next) next.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    if (!pasted) return;

    const newValueArray = pasted.split("").slice(0, length);
    // Fill remaining with empty strings
    while (newValueArray.length < length) {
      newValueArray.push("");
    }
    onChange(newValueArray.slice(0, length).join(""));

    // Focus last filled position
    const lastIndex = Math.min(pasted.length - 1, length - 1);
    const next = document.getElementById(`pin-${lastIndex}`);
    if (next) next.focus();
  };

  const handleFocus = (index) => {
    // Select the input on focus for better UX
    const input = document.getElementById(`pin-${index}`);
    if (input) {
      input.select();
    }
  };

  return (
    <Stack
      direction="row"
      spacing={isMobile ? 1 : 2}
      justifyContent="center"
      width="100%"
    >
      {values.map((digit, index) => (
        <TextField
          key={index}
          id={`pin-${index}`}
          value={digit}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          onPaste={handlePaste}
          onFocus={() => handleFocus(index)}
          inputProps={{
            maxLength: 1,
            inputMode: "numeric",
            style: {
              textAlign: "center",
              fontSize: isMobile ? "14px" : "20px",
              fontWeight: 600,
              padding: 0,
            },
          }}
          sx={{
            width: isMobile ? 42 : 70,
            height: isMobile ? 42 : 70,
            "& .MuiInputBase-root": {
              height: "100%",
            },
          }}
        />
      ))}
    </Stack>
  );
}
